/**
 * Проста картка розділу.
 *
 * Замінює зв'язку `div.card > div.surface-section` з довільними
 * PrimeFlex-класами, які раніше копіювалися з екрана на екран.
 */
const Card = ({ title, subtitle, actions, flush = false, className = '', children }) => (
    <section className={`rc-card ${className}`.trim()}>
        {(title || actions) && (
            <header className="rc-card__header">
                <div>
                    {title && <h2 className="rc-card__title">{title}</h2>}
                    {subtitle && <p className="rc-card__subtitle">{subtitle}</p>}
                </div>
                {actions && <div className="rc-card__actions">{actions}</div>}
            </header>
        )}
        <div className={`rc-card__body ${flush ? 'rc-card__body--flush' : ''}`.trim()}>
            {children}
        </div>
    </section>
);

export default Card;
